export const questionsAndAnswers = [
  {
    id: 0,
    question: "Which of the following is correct about callbacks?",
    options: [
      "A callback is a function that is passed to another function as an argument",
      "A callback is not a function that is passed to another function as an argument",
      "None of above",
    ],
    answer: [
      "A callback is a function that is passed to another function as an argument",
    ],
  },

  {
    id: 1,
    question: "Which of the following functions converts a number to a string?",
    options: ["toString()", "toFixed()", "toLocaleString()", "toPrecision()"],
    answer: "toString()",
  },

  {
    id: 2,
    question: "What does `undefined` mean in JavaScript?",
    options: [
      "Undefined means a variable has been declared but has not yet been assigned a value",
      "Undefined means a function didn’t return any value",
      "All of the above",
      "None of the above",
    ],
    answer: "All of the above",
  },

  {
    id: 3,
    question:
      "If we declare a variable, let test = 1, then reassign it to test = 2, what will happen?",
    options: [
      "test will equal 2",
      "test will equal 1",
      "a TypeError will occur",
      "test will equal undefined",
    ],
    answer: "test will equal 2",
  },

  {
    id: 4,
    question: "How do you debug code in JavaScript?",
    options: [
      "Use breakpoints on Chrome DevTool",
      "console.log()",
      "debugger",
      "All of the above",
      "None of the above",
    ],
    answer: "All of the above",
  },

  {
    id: 5,
    question:
      "How do you prompt users with messages and at the same time request user input?",
    options: ["alert()", "display()", " prompt()", "confirm()"],
    answer: "prompt()",
  },

  {
    id: 6,
    question: "Javascript is not asynchronous",
    options: ["True", "False"],
    answer: "False",
  },

  {
    id: 7,
    question: "What is the difference between an argument and a parameter?",
    options: [
      "An argument is a variable declared in a function, a parameter is an actual value that is passed to the function",
      "A parameter is a variable declared in a function, an argument is an actual value that is passed to the function",
      "All of the above",
      "None of the above",
    ],
    answer:
      "A parameter is a variable declared in a function, an argument is an actual value that is passed to the function",
  },

  {
    id: 8,
    question: "setTimeOut() is executed by Web API",
    options: ["True", "False"],
    answer: "True",
  },

  {
    id: 9,
    question: "What is new in ES6?",
    options: [
      "Symbol data type",
      "The let and const keywords",
      "Arrow function",
      "B and C, but not A",
      "A, B, C",
      "A, B",
    ],
    answer: "A, B, C",
  },

  {
    id: 10,
    question:
      "How do you find out which character occurs at the 5th position in a string `How are you`?",
    options: ["substring()", " string()", "stringlength()", " charAt()"],
    answer: "charAt()",
  },

  {
    id: 11,
    question: "What is lexical scope?",
    options: [
      "A variable that can be accessed by all other functions",
      "A variable that can only be determined by the region where it's created and defined",
      "All of the above",
      "None of the above",
    ],
    answer:
      "A variable that can only be determined by the region where it's created and defined",
  },
];
